let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7YSlr")).then(() => parcelRequire('9gt51'));